import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-expired-token',
  templateUrl: './expired-token.component.html',
  styleUrls: ['./expired-token.component.scss']
})
export class ExpiredTokenComponent {

  @Output() done = new EventEmitter<void>();
}
